// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__YrwAZ","main":"layout_main__J3qaU","footer":"layout_footer__WPmaJ"};